<template lang="pug">
.mobile-sale-point
	MobileMenuBar(
		:show-search="showMenuBarSearch"
		:show-customer="showMenuBarCustomer"
		:show-sale="showMenuBarSale"
		@search="handleSearch"
		@sale="handleSale"
		@customer="handleCustomer"
        @sales:list="handleSalesList"
        @receivable:list="handleReceivableList"
		)
	v-snackbar(
		:value="showSnack"
		:color="snackColor"
		:timeout="0"
		) 
		v-layout(wrap)
			v-flex.xs10( 
				style="display: flex; align-items: center;"
				)
				span {{snackMessage}}
			v-flex.xs2
				v-btn(
					small
					icon
					dark
					@click="showSnack = false"
					)
					v-icon close
	router-view
</template>

<script>
import MobileMenuBar from './MobileMenuBar'
import { mapState, mapActions } from 'vuex'
export default {
    components: { MobileMenuBar },
    computed: {
        showMenuBarSearch() {
            return ['mobileCart', 'mobileCustomer'].includes(this.$route.name)
        },
        showMenuBarSale() {
            return [
                'mobileItemSearch',
                'mobileCustomer',
                'groundSellerSalesList',
                'receivableList',
            ].includes(this.$route.name)
        },
        showMenuBarCustomer() {
            return [
                'mobileCart',
                'groundSellerSalesList',
                'receivableList',
            ].includes(this.$route.name)
        },
        showSnack: {
            get() {
                return this.snackActive
            },
            set(val) {
                if (!val) this.killSnackbar()
            },
        },
        ...mapState('MobileSnackbarModule', {
            snackActive: 'active',
            snackColor: 'color',
            snackMessage: 'message',
        }),
    },
    methods: {
        handleSearch() {
            this.$router.push('/mobile/search')
        },
        handleSale() {
            this.$router.push('/mobile/')
        },
        handleCustomer() {
            this.$router.push('/mobile/customer')
        },
        handleSalesList() {
            this.$router.push('/mobile/sales_list')
        },
        handleReceivableList() {
            this.$router.push('/mobile/receivable_list')
        },
        ...mapActions('MobileSnackbarModule', {
            killSnackbar: 'killSnackbar',
        }),
    },
    mounted() {
        window.onbeforeunload = function(event) {
            return confirm('Confirm refresh')
        }
    },
    beforeDestroy() {
        window.onbeforeunload = function(e) {
            return
        }
    },
}
</script>

<style lang="scss" scoped>
.mobile-sale-point {
    height: 100vh;
    overflow: hiden;
}
</style>
